// assets/dh-editor-insert.js
// Boots the DH editor on /pages/editor. Reads ?project_id/?product/?color
// from the URL, resolves the right apparel background based on whether the
// user has uploaded a logo, then either reuses or creates a project and
// inserts the editor into #editor-container.
(function () {
  DH.configure("guest");

  // ---------- URL parsing ----------
  const QS = new URLSearchParams(location.search);

  // product can be "hat", "hoodie", or "hat-white"/"hoodie-tan"
  function parseProductParam() {
    const raw = (QS.get("product") || "").toLowerCase().trim();
    if (!raw) return { base: null, suffixColor: null };
    const m = raw.match(/^(hat|hoodie)(?:-([a-z0-9-]+))?$/i);
    if (m) return { base: m[1].toLowerCase(), suffixColor: m[2] || null };
    return { base: raw, suffixColor: null };
  }

  const { base: productHandleRaw, suffixColor } = parseProductParam();
  const isApparel = DH.isApparelType(productHandleRaw);

  // Color: ?color= wins, then apparel suffix, then default white for apparel.
  const selectedColor =
    (QS.get("color") || "").toLowerCase().trim() ||
    (isApparel ? (suffixColor || "white") : "");

  const productHandle = productHandleRaw || "sticker";
  const projectId = (QS.get("project_id") || "").trim();
  const tcoHash = DH.readTcoHash();

  // Apparel uses the shared "product-apparel" template; non-apparel uses
  // the handle as the template_code directly.
  const templateCode = isApparel ? "product-apparel" : productHandle;

  // ---------- Color menu sync ----------
  // Radio values are capitalized (White/Tan/Purple) but our color is
  // lowercased from the URL, so compare case-insensitively.
  function syncColorMenu(color) {
    if (!color) return;
    const menu = document.querySelector(".dh-color-menu");
    if (!menu) return;
    const want = color.toLowerCase();
    const match = [...menu.querySelectorAll('input[type="radio"]')]
      .find((r) => (r.value || "").toLowerCase() === want);
    if (match) match.checked = true;
  }

  // ---------- Editor insert / project handling ----------
  function insertEditorWithProject(pid) {
    const insertCfg = { project_id: pid };

    if (isApparel) {
      // Logo uploaded → "-blank.png" so the user's design lands on a clean
      // canvas. No logo → "-default.png" (apparel with built-in placeholder)
      // and no customizations: show the demo product as-is.
      const apparel = DH.buildApparelParams(
        productHandle,
        selectedColor || "white",
        DH.hasUploadedLogo()
      );
      if (apparel) Object.assign(insertCfg, apparel);
    }

    DSHDLib.Editors.insert("editor-container", insertCfg, function (err, editor) {
      if (err) {
        console.error("[DH] editor insert error:", err);
        return;
      }
      window.editor = editor;
      syncColorMenu(selectedColor || "white");
      // Refresh-safety: make sure ?color= is present in the URL.
      if (isApparel && !QS.get("color")) {
        const url = new URL(location.href);
        url.searchParams.set("color", selectedColor || "white");
        history.replaceState(null, "", url.toString());
      }
    });
  }

  function createProjectThenInsert() {
    DSHDLib.createProject(
      {
        template_code: templateCode,
        ...(tcoHash ? { customizations_hash: tcoHash } : {})
      },
      function (err, res) {
        if (err || !res?.project_id) {
          console.error("[DH] createProject error:", err || res);
          return;
        }
        // Stamp project_id into the URL so reloads don't duplicate projects.
        const url = new URL(location.href);
        url.searchParams.set("project_id", res.project_id);
        history.replaceState(null, "", url.toString());

        insertEditorWithProject(res.project_id);
      }
    );
  }

  // ---------- Boot ----------
  if (projectId) {
    insertEditorWithProject(projectId);
  } else {
    createProjectThenInsert();
  }
})();
